module.exports = __webpack_public_path__ + "media/application/images/projects/images/arctic_circle-728a43620cad58dcd64a5bf4802bc348.jpg";